/** Factures émises, paiements et envois. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const InvoicesPage = lazy(() => import('./InvoicesPage.js').then((m) => ({ default: m.InvoicesPage })));
const InvoiceDetail = lazy(() => import('./InvoiceDetail.js').then((m) => ({ default: m.InvoiceDetail })));
const InvoicePaymentPage = lazy(() => import('./InvoicePaymentPage.js').then((m) => ({ default: m.InvoicePaymentPage })));
const DocumentEditorPage = lazy(() => import('../documents/DocumentEditorPage.js').then((m) => ({ default: m.DocumentEditorPage })));
const DocumentEmailPage = lazy(() => import('../documents/DocumentActions.js').then((m) => ({ default: m.DocumentEmailPage })));

const view = { anyOf: ['invoice.view'] } as const;
const manage = { anyOf: ['invoice.manage'] } as const;

export const invoicesRoutes: AppRoute[] = [
  { path: '/factures', element: <InvoicesPage />, gate: view },
  { path: '/factures/nouvelle', element: <DocumentEditorPage kind="invoice" mode="new" />, gate: manage },
  { path: '/factures/:id', element: <InvoiceDetail />, gate: view },
  { path: '/factures/:id/paiement', element: <InvoicePaymentPage />, gate: { anyOf: ['payment.record'] } },
  { path: '/factures/:id/envoi-email', element: <DocumentEmailPage kind="invoice" />, gate: manage },
  { path: '/factures/:id/modifier', element: <DocumentEditorPage kind="invoice" mode="edit" />, gate: manage },
];
